import React from "react";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PrecentLogo from "../../assets/svg/percent-green.svg";
import CheckLogo from "../../assets/svg/blue-check.svg";
const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: "none",
  borderBottom: `1px solid #EAECF0`,
  borderRadius: "0px",
  padding: "0",
  margin: "0",
  "&:last-child": {
    borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiAccordionSummary-content": {
    margin: "0",
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  borderTop: "none",
  padding: "0px",
}));

const AccordionSection = ({ expanded, onChange }: { expanded: string, onChange: (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => void }) => {
 

  return (
    <div className="mt-[48px] rounded-[20px] border-[1px] border-bg-color-1 sm:border-white sm:bg-white p-[12px]">
      <Accordion
        expanded={expanded === "panel1"}
        onChange={onChange("panel1")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          style={{ padding: "0", margin: "0" }}
          className="text-[14px] leading-[18px] sm:text-[18px] sm:leading-[22px] font-bold"
        >
          <img
            src={CheckLogo}
            alt="CheckLogo"
            style={{ marginRight: "10px", width: "24px" }}
          />{" "}
          <span
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            Benefits
          </span>
        </AccordionSummary>
        <AccordionDetails>
          <div className="border-b-[1px] border-bg-color-1 py-[16px] ml-[25px] pt-[10px]">
            <div className="text-[12px] leading-[18px] lg:text-[18px] lg:leading-[30px] font-semibold mb-[8px]">
              Teleconsultations
            </div>
            <div className="text-[12px] leading-[18px] lg:text-[18px] lg:leading-[22px]">
              Unlimited doctor consultations by phone for 12 months
            </div>
          </div>
          <div className="border-b-[1px] border-bg-color-1 py-[16px] ml-[25px] pt-[10px]">
            <div className="text-[12px] leading-[18px] lg:text-[18px] lg:leading-[30px] font-semibold mb-[8px]">
              Nutrition
            </div>
            <div className="text-[12px] leading-[18px] lg:text-[18px] lg:leading-[22px]">
            4 virtual sessions with a nutrition coach
            </div>
          </div>
          <div className="py-[16px] ml-[25px] pt-[10px]">
            <div className="text-[12px] leading-[18px] lg:text-[18px] lg:leading-[30px] font-semibold mb-[8px]">
              Discounts
            </div>
            <div className="text-[12px] leading-[18px] lg:text-[18px] lg:leading-[22px]">
              Discounts on medicines and lab tests
            </div>
          </div>
        </AccordionDetails>
      </Accordion>
      {/* <Accordion
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
          style={{ padding: "0", margin: "0", marginTop: "12px" }}
          className="text-[14px] leading-[18px] sm:text-[18px] sm:leading-[22px] font-bold"
        >
          <img
            src={PrecentLogo}
            alt="PrecentLogo"
            style={{ marginRight: "10px", width: "24px" }}
          />
          <span
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            Discounts
          </span>
        </AccordionSummary>
        <AccordionDetails>
          <div className="border-b-[1px] border-bg-color-1 py-[16px] ml-[25px] pt-[10px]">
            <div className="text-[12px] leading-[18px] lg:text-[18px] lg:leading-[30px] font-semibold mb-[8px]">
              Advanced Diagnostics
            </div>
            <div className="text-[12px] leading-[18px] lg:text-[18px] lg:leading-[22px]">
              Up to 20% off on MRI, CT scan, Ultrasound, PET scan
            </div>
          </div>
          <div className="border-b-[1px] border-bg-color-1 py-[16px] ml-[25px]">
            <div className="text-[12px] leading-[18px] lg:text-[18px] lg:leading-[30px] font-semibold mb-[8px]">
              Medicine Discount
            </div>
            <div className="text-[12px] leading-[18px] lg:text-[18px] lg:leading-[22px]">
              Up to 20% off on medicines
            </div>
          </div>
          <div className="border-b-[1px] border-bg-color-1 py-[16px] ml-[25px]">
            <div className="text-[12px] leading-[18px] lg:text-[18px] lg:leading-[30px] font-semibold mb-[8px]">
              Dental Benefits
            </div>
            <div className="text-[12px] leading-[18px] lg:text-[18px] lg:leading-[22px]">
              Up to 20% off on dental procedures
            </div>
          </div>
          <div className="border-b-[1px] border-bg-color-1 py-[16px] ml-[25px]">
            <div className="text-[12px] leading-[18px] lg:text-[18px] lg:leading-[30px] font-semibold mb-[8px]">
              Lab Tests Discount
            </div>
            <div className="text-[12px] leading-[18px] lg:text-[18px] lg:leading-[22px]">
              Up to 50% off on tests
            </div>
          </div>
          <div className="border-b-[1px] border-bg-color-1 py-[16px] ml-[25px]">
            <div className="text-[12px] leading-[18px] lg:text-[18px] lg:leading-[30px] font-semibold mb-[8px]">
              Eye Surgery Discount
            </div>
            <div className="text-[12px] leading-[18px] lg:text-[18px] lg:leading-[22px]">
              Up to 20% off on cataract and other eye surgeries
            </div>
          </div>
          <div className="border-b-[1px] border-bg-color-1 py-[16px] ml-[25px]">
            <div className="text-[12px] leading-[18px] lg:text-[18px] lg:leading-[30px] font-semibold mb-[8px]">
              Physiotherapy Discount
            </div>
            <div className="text-[12px] leading-[18px] lg:text-[18px] lg:leading-[22px]">
              Up to 20% off on physiotherapy sessions
            </div>
          </div>
          <div className="border-b-[1px] border-bg-color-1 py-[16px] ml-[25px]">
            <div className="text-[12px] leading-[18px] lg:text-[18px] lg:leading-[30px] font-semibold mb-[8px]">
              General Doctor Discount
            </div>
            <div className="text-[12px] leading-[18px] lg:text-[18px] lg:leading-[22px]">
              Up to 30% off on general physician consultations
            </div>
          </div>
          <div className="border-b-[1px] border-bg-color-1 py-[16px] ml-[25px]">
            <div className="text-[12px] leading-[18px] lg:text-[18px] lg:leading-[30px] font-semibold mb-[8px]">
              Eyeglasses Discount
            </div>
            <div className="text-[12px] leading-[18px] lg:text-[18px] lg:leading-[22px]">
              Up to 10% off on eyeglasses
            </div>
          </div>
          <div className="py-[16px] ml-[25px]">
            <div className="text-[12px] leading-[18px] lg:text-[18px] lg:leading-[30px] font-semibold mb-[8px]">
              Specialist Discount
            </div>
            <div className="text-[12px] leading-[18px] lg:text-[18px] lg:leading-[22px]">
              Up to 30% off on specialist doctor consultations
            </div>
          </div>
        </AccordionDetails>
      </Accordion> */}
    </div>
  );
};

export default AccordionSection;
